module.exports = __webpack_public_path__ + "media/images/top-content-img-6-64f0070263fb8f8d056f729e4e27120a.jpg";